import { Interpolation } from "styled-components";

const injectCss: Interpolation<any> = ({ css }) => css;

export default injectCss;
